
export const tedBio = {
  _id: 'tedBioId',
  userId: 'tedUserId',
  email: 'ted@email.com',
  aboutMe: [
    `Architect building a life for himself in New York, hoping to share the roof with someone special`,
    `Chronic overthinker looking for someone to decide once and for all whether I should button the top button or not on my blazer`,
    `Old soul and pedantic over-explainer`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `The girl with the yellow umbrella`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Coffee in the morning, misty rain, and beers with friends`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Favorite shade of pastel`,
    }
  ],
  hobbies: [
    `Architecture`,
    `Bars/Restaurants`,
    `Travel`,
    `Coffee`,
    `Video Games`
  ],
  vitalInfo: {
    firstName: `Ted`, 
    age: 29,
    gender: `Male`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Women`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 73,
    heightCM: 185,
    inOrCmPreference: 'in',
    currentCity: `NYC`,
    hometown: `Ohio`,
    languages: [`English`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: `Postgrad`,
    university: `Haverford`,
    profession: `Architect`,
    employer: ``,
    children: `Don't have children`,
    familyPlans: `Want children`,
    datingIntentions: `Long-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Yes`,
    cigarettes: `No`,
    weed: `Sometimes`,
    drugs: `No`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}

export const robinBio = {
  _id: 'robinBioId',
  userId: 'robinUserId',
  email: 'robin@email.com',
  aboutMe: [
    `Canadian news reporter in New York, always up for a hockey game`,
    `Canadian news reporter in New York, always up for a hockey game`,
    `Canadian news reporter in New York, always up for a hockey game`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `An opportunity to wear my most dazzling dress`,
    },
    {
      prompt: `My simple pleasures`,
      response: `A beer with friends while watching the game`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Favorite maple syrup brand`,
    }
  ],
  hobbies: [
    `Restaurants/Bars`,
    `Pilates`,
    `Running`,
    `Concerts`,
    `Cocktails`
  ],
  vitalInfo: {
    firstName: `Robin`, 
    age: 28,
    gender: `Female`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Men`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 70,
    heightCM: 178,
    inOrCmPreference: 'in',
    currentCity: `NYC`,
    hometown: `Canada`,
    languages: [`English`, `French`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: `Undergrad`,
    university: ``,
    profession: `News Reporter`,
    employer: ``,
    children: `Don't have children`,
    familyPlans: `Want children`,
    datingIntentions: `Long-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Yes`,
    cigarettes: `No`,
    weed: `Sometimes`,
    drugs: `No`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}

export const sluttyPumpkinBio = {
  _id: 'sluttyPumpkinBioId',
  userId: 'sluttyPumpkinUserId',
  email: 'sluttypumpkin@email.com',
  aboutMe: [
    `I dressed in a pumpkin costume one night on Halloween`,
    `I dressed in a pumpkin costume one night on Halloween`,
    `I dressed in a pumpkin costume one night on Halloween`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `My seeds`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Jack-o-lanterns and spiced beverages`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Favorite Thanksgiving dessert`,
    }
  ],
  hobbies: [
    `Farming`,
    `baking`,
    `Coffee`,
    `Art`,
    `Yoga`
  ],
  vitalInfo: {
    firstName: `Slutty Pumpkin`, 
    age: 25,
    gender: `Female`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Men`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 64,
    heightCM: 163,
    inOrCmPreference: 'in',
    currentCity: `NYC`,
    hometown: `Ohio`,
    languages: [`English`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: `Undergrad`,
    university: `Yale`,
    profession: ``,
    employer: ``,
    children: `Don't have children`,
    familyPlans: `Want children`,
    datingIntentions: `Long-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Yes`,
    cigarettes: `No`,
    weed: `No`,
    drugs: `No`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}

export const stellaBio = {
  _id: 'stellaBioId',
  userId: 'stellaUserId',
  email: 'stella@email.com',
  aboutMe: [
    `Dermatologist looking for a connection that's more than skin deep`,
    `Dermatologist looking for a connection that's more than skin deep`,
    `Dermatologist looking for a connection that's more than skin deep`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `A nice, well-educated man who obsesses over minutiae`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Playing Legos with my daughter and going for runs`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Have you ever seen a tattoo you liked?`,
    }
  ],
  hobbies: [
    `Service`,
    `Running`,
    `Coffee`,
    `Travel`,
    `Restaurants/Bars`
  ],
  vitalInfo: {
    firstName: `Stella`, 
    age: 31,
    gender: `Female`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Men`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 67,
    heightCM: 170,
    inOrCmPreference: 'in',
    currentCity: `NYC`,
    hometown: `San Jose`,
    languages: [`English`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: `Postgrad`,
    university: `Stanford`,
    profession: `Dermatologist`,
    employer: ``,
    children: `Have children`,
    familyPlans: `Want children`,
    datingIntentions: `Long-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Yes`,
    cigarettes: `No`,
    weed: `No`,
    drugs: `No`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}

export const tracyBio = {
  _id: 'tracyBioId',
  userId: 'tracyUserId',
  email: 'tracy@email.com',
  aboutMe: [
    `Econ PhD and jazz vocalist living in New York`,
    `Econ PhD and jazz vocalist living in New York`,
    `Econ PhD and jazz vocalist living in New York`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `Someone to hold my yellow umbrella for me`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Rainy days and sundresses`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Best way to end world poverty`,
    }
  ],
  hobbies: [
    `Singing`,
    `Social Work`,
    `Cooking`,
    `Restaurants/Bars`,
    `Economics`
  ],
  vitalInfo: {
    firstName: `Tracy`, 
    age: 28,
    gender: `Female`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Men`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 66,
    heightCM: 168,
    inOrCmPreference: 'in',
    currentCity: `NYC`,
    hometown: `Rhode Island`,
    languages: [`English`],
    religion: [`Prefer not to say`],
    politics: `Liberal`,
    educationLevel: `Postgrad`,
    university: `Columbia`,
    profession: `Economist`,
    employer: ``,
    children: `Don't have children`,
    familyPlans: `Want children`,
    datingIntentions: `Long-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Sometimes`,
    cigarettes: `No`,
    weed: `No`,
    drugs: `No`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}

export const victoriaBio = {
  _id: 'victoriaBioId',
  userId: 'victoriaUserId',
  email: 'victoria@email.com',
  aboutMe: [
    `Your little cupcake is a baker, how ironic`,
    `Your little cupcake is a baker, how ironic`,
    `Your little cupcake is a baker, how ironic`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `The perfect icing to my life`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Brown sugar, salted butter, oh and friends and family too`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Favorite café`,
    }
  ],
  hobbies: [
    `Baking`,
    `Reading`,
    `Restaurants`,
    `Travel`,
    `Pilates`
  ],
  vitalInfo: {
    firstName: `Victoria`, 
    age: 29,
    gender: `Female`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Men`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 65,
    heightCM: 165,
    inOrCmPreference: 'in',
    currentCity: `NYC`,
    hometown: `Virginia`,
    languages: [`English`, `German`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: `Undergrad`,
    university: `Le Cordon Bleu`,
    profession: `Baker`,
    employer: `Buttercups`,
    children: `Don't have children`,
    familyPlans: `Want children`,
    datingIntentions: `Long-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Yes`,
    cigarettes: `No`,
    weed: `No`,
    drugs: `No`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}

export const zoeyBio = {
  _id: 'zoeyBioId',
  userId: 'zoeyUserId',
  email: 'zoey@email.com',
  aboutMe: [
    `Idealist, activist, and your first mate`,
    `Idealist, activist, and your first mate`,
    `Idealist, activist, and your first mate`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `Someone who holds to their morals in all circumstances`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Sit-ins, protests, and days on the ocean`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Would you be in favor of tearing down an old useless landmark for a new modern skyscraper?`,
    }
  ],
  hobbies: [
    `Boating`,
    `Activism`,
    `Social Justice`,
    `Environmentalism`,
    `Running`
  ],
  vitalInfo: {
    firstName: `Zoey`, 
    age: 28,
    gender: `Femal`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Men`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 66,
    heightCM: 167,
    inOrCmPreference: 'in',
    currentCity: `NYC`,
    hometown: `Ohio`,
    languages: [`English`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: `Postgrad`,
    university: `NYU`,
    profession: `Activist`,
    employer: ``,
    children: `Don't have children`,
    familyPlans: `Want children`,
    datingIntentions: `Long-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Yes`,
    cigarettes: `Sometimes`,
    weed: `Sometimes`,
    drugs: `Sometimes`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}